export const info = "i3b4wrq";
export const container = "cztxz0q";
export const sectionHeader = "s1dcyqzq";
export const headerText = "h49307j";
export const content = "cdirt55";
export const itemContainer = "i11z1cpp";
export const navigation = "n1t02k5r";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");